import processPureValue from "./process-pure-value";
import setLevelMap from "./set-level-map";

/**
 * Process 3rd level values separated by the comma (` `) represented by the `▂`
 * @param {String} value
 * @param {MainClassProps} main
 * @param {Map<String, any>} pure
 * @param {StorageItemDataProps} data
 * @param {Map<String, any>} info
 * @example `rgba(255▌1▌2▌2)▂◖-◗33.71%`
 */
const processSpaceSplit = (value, main, pure, data, info) => {
  /**
   * Split the second level parameters by space ` ` represented by the `▂`
   * @example "0%▂1%"
   */
  const split = value.split("▂");

  const path = info.get("path");

  /** @type {ValueLevelMapProps} */
  const map = new Map();

  setLevelMap(map, split, " ", value, false, null, "space");

  /** @type {any} */
  const mapValues = map.get("values") || [];

  /** Value number */
  let number = 0;

  /** Loop trough all items splitted by the space */
  for (let item of split) {
    info.set("path", `${path}>${number}( )`);

    const pureValue = processPureValue(item, main, data, info);

    pure.set(info.get("path"), pureValue);
    mapValues.push(pureValue);

    ++number;
  }

  return map;
};

export default processSpaceSplit;
